import { render, staticRenderFns } from "./privateno.vue?vue&type=template&id=2f2125d8&scoped=true&"
import script from "./privateno.vue?vue&type=script&lang=js&"
export * from "./privateno.vue?vue&type=script&lang=js&"
import style0 from "./privateno.vue?vue&type=style&index=0&id=2f2125d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2125d8",
  null
  
)

export default component.exports